enum WebSocketTypes {
    CREATE_WEBSOCKET_CONNECTION = 'CREATE_WEBSOCKET_CONNECTION',
}

export default WebSocketTypes;